import React, { useState } from 'react';
import { Alert, Badge, Button, Form } from 'react-bootstrap';
import cuescoreService from '../api/CuescoreService';
import { CS_Player } from '../models/cuescore-models';
import httpService from '../api/HttpService';
import { CreatePlayerDTO, Player } from '../models/player';
import { useRedirect } from '../context/RedirectContext';
import { usePlayer } from '../context/PlayerContext';

const CreatePlayer: React.FC = () => {

    const [showCuescore, setShowCuescore] = useState(false);
    const [showDdbu, setShowDdbu] = useState(false);
    const [showEmail, setShowEmail] = useState(false);

    const first = !showCuescore && !showDdbu && !showEmail;


    return (
        <div>
            {first &&
                <CreatePlayerSelector
                    onCuescoreClick={() => setShowCuescore(true)}
                    onDdbuClick={() => setShowDdbu(true)}
                    onEmailClick={() => setShowEmail(true)} />
            }
            {showCuescore && <CreatePlayerCuescore />}
            {showDdbu && <CreatePlayerDDBU />}
            {showEmail && <CreatePlayerEmail />}
        </div>
    );
};

export default CreatePlayer;

interface SelectorProps {
    onDdbuClick?: () => void;
    onCuescoreClick?: () => void;
    onEmailClick?: () => void;
}

export const CreatePlayerSelector: React.FC<SelectorProps> = (props: SelectorProps) => {
    const { onCuescoreClick, onDdbuClick, onEmailClick } = props;

    return (
        <div>
            <div className="header">
                <h1>Create player</h1>
            </div>
            <div>

                <h3>With cuescore account <Badge variant='success'>Recommended</Badge></h3>
                <p>If you have a cuescore account, we recommend using this option, as it will link to any existing tournament matches.</p>
                <p>
                    <Button onClick={onCuescoreClick}>
                        Create player with Cuescore account
                    </Button>
                </p>

            </div>
            <hr></hr>
            <div>
                <h3>Other options</h3>
                <h5>With DDBU license number</h5>
                <Button variant='secondary' onClick={onDdbuClick}>Create player with DDBU license</Button>
            </div>
            <hr></hr>
            <div>
                <h5>With email</h5>
                <Button variant='secondary' onClick={onEmailClick}>Create player with email</Button>
            </div>
        </div>
    );
}

export const CreatePlayerEmail: React.FC = () => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [exception, setException] = useState<string | undefined>();

    const [message, setMessage] = useState('');

    const submit = async () => {
        const player: CreatePlayerDTO = {
            firstName: firstName.trim(),
            lastName: lastName.trim(),
            email: email,
        };
        try {
            const resp = await httpService.post<CreatePlayerDTO>('api/players', player);

            if (resp) {
                setMessage(`An email has been sent to ${email}. Please check your email to continue`);
            }
        }
        catch (e) {
            console.log(e);
            setException("A player or player creation request with this email already exists");
        }
    }

    return (
        <div>
            <div className="header">
                <h1>Create player with email</h1>
            </div>
            <Form>
                <Form.Group controlId="formBasicText">
                    <Form.Label>First name</Form.Label>
                    <Form.Control
                        type="text"
                        name="username"
                        placeholder="First name"
                        value={firstName}
                        onChange={e => setFirstName(e.target.value)}
                    />
                </Form.Group>
                <Form.Group controlId="formBasicText">
                    <Form.Label>Last name</Form.Label>
                    <Form.Control
                        type="text"
                        name="username"
                        placeholder="First name"
                        value={lastName}
                        onChange={e => setLastName(e.target.value)}
                    />
                </Form.Group>
                <hr></hr>
                <Form.Group controlId="formBasicText">
                    <Form.Label>Email is used for verification</Form.Label>
                    <Form.Control
                        type="email"
                        name="username"
                        placeholder="Email"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                    />
                </Form.Group>
                {exception &&
                    <Alert variant="warning"><strong>{exception}</strong></Alert>
                }
                {message ?
                    <Alert variant="success"><strong>{message}</strong></Alert>
                    :
                    <button
                        type="button"
                        className="btn btn-lg btn-primary w-100"
                        onClick={submit}>
                        Create
                    </button>
                }

            </Form>
        </div>
    )
}

export const CreatePlayerDDBU: React.FC = () => {

    const [id, setId] = useState('');
    const [player, setPlayer] = useState<CreatePlayerDTO>();

    const [exception, setException] = useState<string | undefined>();

    const find = async () => {
        if (id) {
            try {
                const player = await httpService.anonGet<CreatePlayerDTO>(`api/players/ddbu/${id}`);
                setException(undefined);
                setPlayer(player);
            }
            catch (e) {
                setException("Could not find any player with id " + id);
            }
        }
    }

    return (
        <div>
            <div className="header">
                <h1>Create player with DDBU license number</h1>
            </div>
            {player ?
                <CreatePlayerForm name={`${player.firstName} ${player.lastName}`} ddbuLicenseNumber={player.licenseNumber} onGoBack={() => setPlayer(undefined)}></CreatePlayerForm>
                :
                <Form>
                    <Form.Group controlId="formBasicText">
                        <Form.Label>Enter DDBU license number</Form.Label>
                        <Form.Control
                            type="text"
                            name="username"
                            placeholder="Search"
                            value={id}
                            onChange={e => setId(e.target.value)}
                        />
                    </Form.Group>
                    {exception &&
                        <Alert variant="warning"><strong>{exception}</strong></Alert>
                    }
                    <button
                        type="button"
                        className="btn btn-lg btn-primary w-100"
                        onClick={find}>
                        Find
                    </button>
                </Form>
            }
        </div>
    );
}

export const CreatePlayerCuescore: React.FC = () => {

    const [id, setId] = useState('');
    const [csPlayer, setCsPlayer] = useState<CS_Player>();
    const [exception, setException] = useState<string | undefined>();
    const find = async () => {
        if (id) {
            let parsedId = id;
            try {
                const url = new URL(id);
                const parts = url.pathname.split('/').filter(Boolean);
                if (parts.length > 0) {
                    parsedId = parts[parts.length - 1];
                }
            } catch {
                // id is not a URL, use as is
            }
            const player = await cuescoreService.getPlayerInfo(parsedId);
            if (player.playerId) {
                console.log("CS player", player);
                setException(undefined);
                setCsPlayer(player);
            }
            else {
                setException("Could not find any player with id " + id);
            }
        }
    }

    return (
        <div>
            <div className="header">
                <h1>Create player with cuescore</h1>
            </div>
            {!csPlayer &&
                <>
                    <Form>
                        <Form.Group controlId="formBasicText">
                            <Form.Label>Enter cuescore id or profile url</Form.Label>
                            <Form.Control
                                type="text"
                                name="username"
                                placeholder="Search"
                                value={id}
                                onChange={e => setId(e.target.value)}
                            />
                        </Form.Group>
                        {exception &&
                            <Alert variant="warning"><strong>{exception}</strong></Alert>
                        }
                        <button
                            type="button"
                            className="btn btn-lg btn-primary w-100"
                            onClick={find}>
                            Find
                        </button>
                    </Form>
                    <hr></hr>
                    <div className="header">
                        <h2>How to find your cuescore id</h2>
                    </div>
                    <p>
                        <a href="https://cuescore.com/players" target='_blank'>Click here</a> or the button below to go to your cuescore profile.
                        If you are not logged in, do so by clicking on the Sign in button at the top.
                    </p>
                    <p>
                         <a href="https://cuescore.com/players" target='_blank'><Button>Go to Cuescore profile</Button></a>  
                    </p>
                    <p>Then click on the Share button:</p>
                    <img src="cuescore-1.png" className="img-fluid mb-4"></img>
                    <p>And then click on the button that copies it to your clipboard:</p>
                    <img src="cuescore-2.png" className="img-fluid mb-4"></img>
                    <p>Return to this page and paste it in the form at the top!</p>
                </>
            }
            {csPlayer &&
                <CreatePlayerForm name={csPlayer.name} cuescoreId={csPlayer.playerId} imageUrl={csPlayer.image} onGoBack={() => setCsPlayer(undefined)}></CreatePlayerForm>
            }
        </div>
    );
};

interface FormProps {
    name: string;
    cuescoreId?: number;
    ddbuLicenseNumber?: string;
    imageUrl?: string;
    email?: string;
    onGoBack?: () => void;
}

const CreatePlayerForm: React.FC<FormProps> = (props: FormProps) => {
    const { name, cuescoreId, ddbuLicenseNumber, imageUrl, email, onGoBack } = props;

    const [playerName, setPlayerName] = useState(name);
    const { url, setUrl } = useRedirect();
    const { player, setPlayer } = usePlayer();

    const create = async () => {
        const player: CreatePlayerDTO = {
            altId: cuescoreId?.toString(),
            licenseNumber: ddbuLicenseNumber,
            firstName: playerName.trim().split(' ').slice(0, -1).join(' '),
            lastName: playerName.trim().split(' ').slice(-1).join(' '),
            email: email,
        };
        const resp = await httpService.post<CreatePlayerDTO>('api/players', player);

        const p = await httpService.anonGet<Player>(`api/players/${resp.id}`);
        await setPlayer(p);
        if (url) {
            window.location.href = url;
        }
    }

    return (
        <div>
            <Form>
                <div className='d-flex justify-content-between'>
                    <Form.Group controlId="formBasicText" style={{ flexGrow: 1 }}>
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                            type="text"
                            name="username"
                            placeholder="Search"
                            disabled={!!cuescoreId}
                            value={playerName}
                            onChange={e => setPlayerName(e.target.value)}
                        />
                        {cuescoreId &&
                            <p>Cuescore id: {cuescoreId}</p>
                        }
                    </Form.Group>
                    {imageUrl &&
                        <div>
                            <img
                                src={imageUrl}
                                alt={`${playerName}`}
                                style={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: '50%', marginLeft: '20px' }}
                            />
                        </div>
                    }
                </div>
                <p>
                    <div>By clicking Create, you confirm that you are </div>
                    <i>{playerName}</i>
                </p>
                <button
                    type="button"
                    className="btn btn-lg btn-primary w-100"
                    onClick={create}>
                    Create
                </button>
                <hr></hr>
                <button
                    type="button"
                    className="btn btn-secondary w-100"
                    onClick={onGoBack}>
                    Not you? - Go back
                </button>
            </Form>
        </div>
    );
};